import { ListingState } from '@ha/api/v2/types/Listing';

export const ListingStateName = {
  [ListingState.DRAFT]: 'Draft',
  [ListingState.PUBLISHED]: 'Published',
  [ListingState.UNPUBLISHED]: 'Unpublished',
};

export enum ListingStateFilter {
  ALL = 'all',
  PUBLISHED = 'published',
  UNPUBLISHED = 'unpublished',
  DRAFT = 'draft',
}

export enum ListingActions {
  PUBLISH = 'publish',
  UNPUBLISH = 'unpublish',
}
